/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The years/months/days breakdown is calculated from real calendar dates, so it automatically accounts for February having 28 or 29 days and for months of 28–31 days. A leap year adds one extra day to that February, and the calculator picks it up without any special-casing needed.`)
};

const es_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El desglose de años/meses/días se calcula a partir de fechas reales del calendario, por lo que automáticamente tiene en cuenta que febrero tiene 28 o 29 días y que los meses tienen de 28 a 31 días. Un año bisiesto añade un día extra a ese febrero, y la calculadora lo detecta sin necesidad de ningún caso especial.`)
};

const de_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aufschlüsselung der Jahre/Monate/Tage wird aus echten Kalenderdaten berechnet, daher berücksichtigt sie automatisch, dass Februar 28 oder 29 Tage hat und Monate 28–31 Tage. Ein Schaltjahr addiert einen extra Tag zu diesem Februar, und der Rechner erfasst ihn, ohne dass spezielle Behandlung erforderlich ist.`)
};

const nl_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De uitsplitsing jaren/maanden/dagen wordt berekend op basis van echte kalenderdatums, dus het houdt automatisch rekening met februari die 28 of 29 dagen heeft en maanden van 28–31 dagen. Een schrikkeljaar voegt één extra dag toe aan die februari, en de calculator pikt het op zonder dat er speciale behandeling nodig is.`)
};

const fr_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ventilation années/mois/jours est calculée à partir des dates réelles du calendrier, elle tient donc automatiquement compte du fait que février a 28 ou 29 jours et que les mois ont 28–31 jours. Une année bissextile ajoute un jour supplémentaire à ce février, et la calculatrice le détecte sans aucun cas particulier nécessaire.`)
};

const it_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'analisi anni/mesi/giorni viene calcolata da date di calendario reali, quindi tiene automaticamente conto del fatto che febbraio ha 28 o 29 giorni e i mesi hanno 28–31 giorni. Un anno bisestile aggiunge un giorno extra a febbraio, e il calcolatore lo rileva senza alcuna necessità di casi speciali.`)
};

const pt_br2_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A divisão anos/meses/dias é calculada a partir de datas de calendário reais, portanto, leva automaticamente em conta fevereiro tendo 28 ou 29 dias e meses de 28–31 dias. Um ano bissexto adiciona um dia extra a fevereiro, e a calculadora detecta isso sem nenhuma manipulação especial necessária.`)
};

const pt_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A decomposição de anos/meses/dias é calculada a partir de datas reais do calendário, portanto conta automaticamente com fevereiro tendo 28 ou 29 dias e com meses de 28 a 31 dias. Um ano bissexto adiciona um dia extra a esse fevereiro, e a calculadora detecta sem necessidade de tratamento especial.`)
};

const ja_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年/月/日の内訳は実際のカレンダー日付から計算されるため、2月が28日または29日であること、および28〜31日の月を自動的に考慮します。閏年は2月に1日追加し、計算機は特別なケーシングなしでそれを選び出します。`)
};

const zh_dd_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年/月/日的明细是根据真实日历日期计算的，因此会自动考虑2月有28天或29天、以及各月28至31天不等的情况。闰年会为2月多增加一天，计算器无需任何特殊处理即可自动识别这一点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_faq3_a", locale)
	if (locale === "en") return en_dd_faq3_a(inputs)
	if (locale === "es") return es_dd_faq3_a(inputs)
	if (locale === "de") return de_dd_faq3_a(inputs)
	if (locale === "nl") return nl_dd_faq3_a(inputs)
	if (locale === "fr") return fr_dd_faq3_a(inputs)
	if (locale === "it") return it_dd_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_dd_faq3_a(inputs)
	if (locale === "pt") return pt_dd_faq3_a(inputs)
	if (locale === "ja") return ja_dd_faq3_a(inputs)
	return zh_dd_faq3_a(inputs)
};